import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { checklistComponents } from './FunctionChecklist'
import { useLocation } from "react-router";
import { FaPrint } from "react-icons/fa";
import { ToastComponent } from "../Components/ToastComponent";
import posthog from "../../Services/posthog";

export default function Checklist() {
  const dispatch = useDispatch();
  let location = useLocation();
  const [checkinList, setCheckinList] = useState(null)
	dispatch({ type: "title", value: "Checklist" });
  const [toastParams, setToastParams] = useState('');

  useEffect(() => {
    try {
      if(location.state.checkout) {
        let parsedCheckout = JSON.parse(location.state.checkout)
        setCheckinList(parsedCheckout)
      }
    } catch (err) {
      setToastParams(JSON.stringify({ show: true, title: "Checklist inválido", body: 'Conteudo inválido, tente outro checklist', color: 'danger' }));
    }
  }, [location.state?.checkout])

  const handlePrint = () => {
    posthog.capture("checklist submitted", {
      item_count: checkinList?.length ?? 0,
    });
    const cardHtml = document.getElementById('card-checkout-list').innerHTML
    let html = `
      <html lang="pt-br">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
          <link
            rel="stylesheet"
            href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
            integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
            crossorigin="anonymous"
          ></link>
          <style>
            @media print {
              .no-print {
                display: none;
              }
            }
          </style>
        </head>
        <body onload="window.print();window.setTimeout('window.close()',1000)">
    `
    html = html + cardHtml
    html = html + '</body></html>'

    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
  }

  return (
    <>
      <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="card">
          <div className="card-header no-print d-flex justify-content-end">
            <button type='button' className='btn btn-primary' onClick={handlePrint}>
              <FaPrint />
            </button>
          </div>
          <div className="card-body" id="card-checkout-list">
            <div className="row">
              {checkinList?.map((field, index) => (
                  <>
                      {checklistComponents(field.field)}
                  </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}